{
  "newAnnouncement": "È presente un nuovo annuncio",
  "notification": "Notifiche e annunci",
  "unread": "notifiche non lette"
}
